import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { OpenIdService } from 'src/app/service/open-id.service';
import {
    HistoryModelInterface,
    HistoryModelResponse,
} from 'src/app/interface/history-model.interface';
import { PaginatorMixin } from 'src/app/mixin/paginator.mixin';
import { OpenIdProfileMixin } from 'src/app/mixin/open-id-profile.mixin';
import { MatDialog } from '@angular/material/dialog';

import { WithdrawalComponent } from 'src/app/dialog/ledger/request/withdrawal/withdrawal.component';

import { TransactionModel } from 'src/app/interface/transaction-model.interface';

class BaseExtend {
    constructor(protected openIdService: OpenIdService) {}
}
const FinalExtended = OpenIdProfileMixin(PaginatorMixin(BaseExtend));

@Component({
    selector: 'app-component-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.css'],
})
export class HistoryComponent
    extends FinalExtended
    implements AfterViewInit, OnInit
{
    public historyModels: HistoryModelInterface[] = [];
    public lastHistory?: HistoryModelInterface;

    public columnHeadings: string[] = [
        'id',
        'balance',
        'amount',
        'transaction',
        'result',
        'created_at',
    ];

    private offset = 0;
    @ViewChild(MatPaginator) public paginator?: MatPaginator;

    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        openIdService: OpenIdService
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        this.$openIdReady.subscribe(() => this.getRecords());
    }

    ngAfterViewInit(): void {
        this.handlePaging(this.paginator!, (offset) => this.getRecords(offset));
    }

    public getRecords(offset: number = 0) {
        this.offset = offset;
        let params = new HttpParams()
            .set('offset', offset)
            .set('limit', this.pagingPageSize)
            .set('view', 'transaction')
            .set('ordering', '-created_at');

        this.httpClient
            .get<HistoryModelResponse>('historys/', { params: params })
            .subscribe((response: HistoryModelResponse) => {
                if (!this.lastHistory && response.count > 0) {
                    this.lastHistory = response.results[0];
                }
                this.pagingItemCount = response.count;
                this.historyModels = response.results;
            });
    }

    public reload() {
        this.getRecords(this.offset);
    }

    public withdrawal() {
        const dialogRef = this.dialog.open(WithdrawalComponent);
    }
}
